import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { ConfiguratorText } from 'src/components/atoms/configurator'
import Link from 'src/components/atoms/input/buttons/Link'
import ChecklistItem from 'src/components/atoms/input/Checklist'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'

@inject('confStore')
@observer
export default class AdditionalInterests extends React.Component<
  StoreProps,
  any
> {
  constructor(props) {
    super(props)
    this.state = { saved: false }
  }

  onSelect = (i) => {
    const { confStore } = this.props
    this.setState({ saved: false })
    confStore.toggleInterest(i)
  }

  render() {
    const { confStore } = this.props
    const { saved } = this.state
    const interests = confStore.getCatalogue.interests
    if (!interests || !interests.length) return null
    return (
      <ConfiguratorBox
        title='Was für Sie sonst noch interessant sein könnte'
        collapsable>
        <ConfiguratorText>
          Gerne beraten wir Sie umfassend zur Bestattung. Wählen Sie hier unten
          Themen aus, zu denen Sie <u>kostenfrei</u> zusätzliche{' '}
          <u>Informationen und Beratung</u> wünschen.
        </ConfiguratorText>
        <div>
          {interests.map((i) => {
            return (
              <ChecklistItem
                key={i.uuid}
                title={i.name}
                checked={confStore.offerHasInterest(i)}
                onClick={() => this.onSelect(i)}
              />
            )
          })}
        </div>
        <Link light onClick={() => this.setState({ saved: true })}>
          {saved ? 'Übernommen \u{2714}' : 'Übernehmen'}
        </Link>
      </ConfiguratorBox>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/AdditionalInterests.tsx